export default __webpack_public_path__ + "static/media/8.f89d421a.svg";